import React, { useState } from 'react'
import {Link} from 'react-router-dom';
import PersonIcon from '@mui/icons-material/Person';
import SchoolIcon from '@mui/icons-material/School';
import LocalPoliceIcon from '@mui/icons-material/LocalPolice';
import WorkIcon from '@mui/icons-material/Work';
import Fab from '@mui/material/Fab';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CV from './CV';
import '../style/Home.css';

function Home() {
  const[Open,setOpen]=useState(true);
  const closeCV=()=>{
    setOpen(true);
  }
  return (
   <>
      <div className='main'>
       <div className='Homediv'>
        <Link to='/personal' className='Homecontent'><PersonIcon className='allIcon'/> Personal Details</Link>
        <Link to='/education' className='Homecontent'><SchoolIcon  className='allIcon'/> Education</Link>
        <Link to='/Objective' className='Homecontent'><WorkIcon  className='allIcon'/> Objective</Link>
        <Link to='/skills' className='Homecontent'><LocalPoliceIcon className='allIcon' /> Skills</Link>
        <Link to='/projects' className='Homecontent'><RocketLaunchIcon className='allIcon' /> Projects</Link>
       </div>
        
       
      </div>
       {
      (Open)?(<Fab variant="extended" size="medium" id='CVButton' color="primary" 
       onClick={()=>setOpen(false)} aria-label="add">
        <VisibilityIcon sx={{ mr: 1 }} />
        View CV
      </Fab>):(
       <CV fun={closeCV}/>)
        }     

    
   
   </>
  )
}

export default Home